import { forwardRef, type Ref, type SVGProps } from "react";
const IconPhoneOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M26.35 2.78 20.63 2a1.75 1.75 0 0 0-1.91 1.16l-2 6.21a1.71 1.71 0 0 0 .69 2l3.24 2.14c-.53 2.33-.82 4.72-5 7.59l-2.86-2.5a1.76 1.76 0 0 0-2.08-.31l-5.8 3.11a1.72 1.72 0 0 0-.82 2.06l1.82 5.41A1.74 1.74 0 0 0 7.73 30c14-1.29 21.44-11.82 20.12-25.71a1.72 1.72 0 0 0-1.5-1.51M7.6 28.29l-1.81-5.35 5.75-3.08 3.78 3.44c5.08-3 6.27-6 7.45-10.51L18.41 9.9l2-6.13 5.66.76c1.21 12.88-5.42 22.53-18.47 23.76"
    />
  </svg>
);
const ForwardRef = forwardRef(IconPhoneOutlineSVG);
ForwardRef.displayName = "IconPhoneOutline";
export { ForwardRef as IconPhoneOutline };
